import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { SuccessResponse, LockUserType } from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';

export const useLockIndependentIraUser = () => {
  const queryClient = useQueryClient();

  const mutate = async ({ id, payload }: LockUserType) => {
    const { data } = await api.lockIndependentIraUser(id, payload);

    return data;
  };

  const mutationKey = MutationKeys.lockIndependentIraUser;

  return useMutation<SuccessResponse, AxiosError<ApiError>, LockUserType>(
    mutationKey,
    mutate,
    {
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries(QueryKeys.independentIraUsers);
        queryClient.invalidateQueries([QueryKeys.independentIraUser, id]);
      },
    },
  );
};
